export const getZoomedValue = (
  value: number,
  zoom: number,
  suffix?: string,
): string | number => {
  const newValue = Math.floor(value * zoom);

  return suffix ? newValue.toString() + suffix : newValue;
};
